import type { SVGProps } from 'react'
const SvgSyClock = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<circle cx={12} cy={12} r={9} fillOpacity={0.24} />
		<path d="M5.129 2.32a.5.5 0 0 0-.379.051A6.5 6.5 0 0 0 2.371 4.75a.5.5 0 0 0 .184.684.5.5 0 0 0 .681-.184A5.5 5.5 0 0 1 5.25 3.236a.5.5 0 0 0 .184-.681.5.5 0 0 0-.305-.235m14.121.051a.5.5 0 0 0-.684.184.5.5 0 0 0 .184.681 5.5 5.5 0 0 1 2.014 2.014.5.5 0 0 0 .681.184.5.5 0 0 0 .184-.684 6.5 6.5 0 0 0-2.379-2.379M12 6a.5.5 0 0 0-.5.5v5.25c0 .408.342.75.75.75h4.25a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5h-4v-5A.5.5 0 0 0 12 6" />
	</svg>
)
export default SvgSyClock
